var _g, _g2, _path, _path2, _g3, _rect, _ellipse, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse2, _path9, _path10, _path11, _g4, _rect2, _g5, _path12, _g6, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLpSniperIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 180,
    viewBox: "0 0 216 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1877_14626)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.1383,
    cy: 105.777,
    rx: 32.2125,
    ry: 32.3827,
    fill: "#8A23FF",
    fillOpacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1877_14626)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.577,
    cy: 76.8239,
    rx: 42.3697,
    ry: 42.5934,
    fill: "#8A23FF",
    fillOpacity: 0.3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3086 69.6753V1",
    stroke: "url(#paint0_linear_1877_14626)",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5626 21.9258L17 21.9258",
    stroke: "url(#paint1_linear_1877_14626)",
    strokeWidth: 0.4
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint2_diamond_1877_14626_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.000289094 0.00176846 -0.00173456 -0.000294744 43.5968 22.2216)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1930.94,
    height: 1913.18,
    fill: "url(#paint2_diamond_1877_14626)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1930.94,
    height: 1913.18,
    transform: "scale(1 -1)",
    fill: "url(#paint2_diamond_1877_14626)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1930.94,
    height: 1913.18,
    transform: "scale(-1 1)",
    fill: "url(#paint2_diamond_1877_14626)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1930.94,
    height: 1913.18,
    transform: "scale(-1)",
    fill: "url(#paint2_diamond_1877_14626)",
    opacity: 1,
    shapeRendering: "crispEdges"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.67301,
    height: 2.6712,
    rx: 0.5,
    transform: "matrix(0.687672 0.726022 -0.712586 0.701585 43.4766 20.4531)",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.78823530673980713,\"g\":0.50588238239288330,\"b\":0.99607843160629272,\"a\":1.0},\"position\":0.12808635830879211},{\"color\":{\"r\":0.43960633873939514,\"g\":0.34214857220649719,\"b\":0.9401855468750,\"a\":1.0},\"position\":0.78659701347351074}],\"stopsVar\":[{\"color\":{\"r\":0.78823530673980713,\"g\":0.50588238239288330,\"b\":0.99607843160629272,\"a\":1.0},\"position\":0.12808635830879211},{\"color\":{\"r\":0.43960633873939514,\"g\":0.34214857220649719,\"b\":0.9401855468750,\"a\":1.0},\"position\":0.78659701347351074}],\"transform\":{\"m00\":-0.57818776369094849,\"m01\":-3.4691274166107178,\"m02\":45.620487213134766,\"m10\":3.5369253158569336,\"m11\":-0.58948719501495361,\"m12\":20.747869491577148},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.663,
    cy: 81.66,
    rx: 46.6474,
    ry: 46.9725,
    stroke: "url(#paint3_linear_1877_14626)",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.406 73.6406V91.9864",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.297 82.8125H125.516",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M60.5859 83.0078H102.063",
    stroke: "white",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M131.133 83.0078H172.61",
    stroke: "white",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M116.406 26.8008V68.5668",
    stroke: "white",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M116.406 97.0625V138.828",
    stroke: "white",
    strokeWidth: 0.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.402,
    cy: 83.0094,
    rx: 3.10107,
    ry: 3.12269,
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M137.906 67.6211C139.746 70.3978 141.067 73.5524 141.731 76.9446L141.633 76.9639C141.951 78.5881 142.118 80.2672 142.118 81.9855C142.118 83.7039 141.951 85.3829 141.633 87.0072L141.731 87.0264C141.067 90.4187 139.746 93.5732 137.906 96.3499L137.822 96.2947C135.955 99.1131 133.552 101.541 130.759 103.43L130.815 103.513C128.05 105.383 124.905 106.728 121.521 107.404L121.502 107.306C119.878 107.631 118.2 107.801 116.482 107.801C114.764 107.801 113.085 107.631 111.462 107.306L111.442 107.404C108.058 106.728 104.913 105.383 102.148 103.513L102.204 103.43C99.4119 101.541 97.0087 99.1131 95.1414 96.2947L95.058 96.3499C93.2183 93.5732 91.8968 90.4187 91.2327 87.0264L91.3308 87.0072C91.0128 85.3829 90.8461 83.7039 90.8461 81.9855C90.8461 80.2672 91.0128 78.5881 91.3308 76.9639L91.2327 76.9446C91.8968 73.5524 93.2183 70.3978 95.058 67.6211L95.1414 67.6763C97.0087 64.858 99.4119 62.4304 102.204 60.5413L102.148 60.4585C104.913 58.588 108.058 57.2434 111.442 56.5669L111.462 56.665C113.085 56.3405 114.764 56.1703 116.482 56.1703C118.2 56.1703 119.878 56.3405 121.502 56.665L121.521 56.5669C124.905 57.2434 128.05 58.588 130.815 60.4585L130.759 60.5413C133.552 62.4304 135.955 64.858 137.822 67.6763L137.906 67.6211Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeDasharray: "9 9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M189.078 98.3169V166.992",
    stroke: "url(#paint4_linear_1877_14626)",
    strokeWidth: 0.4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M142.793 146.039H215.355",
    stroke: "url(#paint5_linear_1877_14626)",
    strokeWidth: 0.4
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint6_diamond_1877_14626_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.000290149 -0.0017733 0.00174089 0.00029555 189.082 145.766)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1928.44,
    height: 1910.68,
    fill: "url(#paint6_diamond_1877_14626)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1928.44,
    height: 1910.68,
    transform: "scale(1 -1)",
    fill: "url(#paint6_diamond_1877_14626)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1928.44,
    height: 1910.68,
    transform: "scale(-1 1)",
    fill: "url(#paint6_diamond_1877_14626)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1928.44,
    height: 1910.68,
    transform: "scale(-1)",
    fill: "url(#paint6_diamond_1877_14626)",
    opacity: 1,
    shapeRendering: "crispEdges"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.68148,
    height: 2.67975,
    rx: 0.5,
    transform: "matrix(-0.688002 -0.725708 0.712906 -0.70126 189.203 147.539)",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.78823530673980713,\"g\":0.50588238239288330,\"b\":0.99607843160629272,\"a\":1.0},\"position\":0.12808635830879211},{\"color\":{\"r\":0.43960633873939514,\"g\":0.34214857220649719,\"b\":0.9401855468750,\"a\":1.0},\"position\":0.78659701347351074}],\"stopsVar\":[{\"color\":{\"r\":0.78823530673980713,\"g\":0.50588238239288330,\"b\":0.99607843160629272,\"a\":1.0},\"position\":0.12808635830879211},{\"color\":{\"r\":0.43960633873939514,\"g\":0.34214857220649719,\"b\":0.9401855468750,\"a\":1.0},\"position\":0.78659701347351074}],\"transform\":{\"m00\":0.58029812574386597,\"m01\":3.4817883968353271,\"m02\":187.05137634277344,\"m10\":-3.5465979576110840,\"m11\":0.59109914302825928,\"m12\":147.24351501464844},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint7_diamond_1877_14626_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.00762617 0.0134774 0.0192819 -0.0128466 116.286 83.3922)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 952.103,
    height: 762.161,
    fill: "url(#paint7_diamond_1877_14626)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 952.103,
    height: 762.161,
    transform: "scale(1 -1)",
    fill: "url(#paint7_diamond_1877_14626)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 952.103,
    height: 762.161,
    transform: "scale(-1 1)",
    fill: "url(#paint7_diamond_1877_14626)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 952.103,
    height: 762.161,
    transform: "scale(-1)",
    fill: "url(#paint7_diamond_1877_14626)",
    opacity: 1,
    shapeRendering: "crispEdges"
  })))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M104.563 94.947C105.1 96.5145 106.804 97.3458 108.37 96.8038L130.737 89.0616C132.303 88.5196 133.137 86.8096 132.6 85.2422L128.009 71.8375C127.472 70.27 125.767 69.4387 124.202 69.9806L101.835 77.7229C100.269 78.2649 99.4348 79.9749 99.9717 81.5423L104.563 94.947Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.44313725829124451,\"g\":0.34509804844856262,\"b\":0.94117647409439087,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.63348329067230225,\"g\":0.56124675273895264,\"b\":1.0,\"a\":1.0},\"position\":0.35127770900726318},{\"color\":{\"r\":0.23911747336387634,\"g\":0.16823393106460571,\"b\":0.59637045860290527,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.44313725829124451,\"g\":0.34509804844856262,\"b\":0.94117647409439087,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.63348329067230225,\"g\":0.56124675273895264,\"b\":1.0,\"a\":1.0},\"position\":0.35127770900726318},{\"color\":{\"r\":0.23911747336387634,\"g\":0.16823393106460571,\"b\":0.59637045860290527,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":15.252341270446777,\"m01\":38.5637207031250,\"m02\":89.377792358398438,\"m10\":26.954854965209961,\"m11\":-25.693262100219727,\"m12\":82.761451721191406},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint8_diamond_1877_14626_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0139654 -0.0019609 -0.00174568 -0.0156872 116.354 83.1997)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1229.94,
    height: 846.343,
    fill: "url(#paint8_diamond_1877_14626)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1229.94,
    height: 846.343,
    transform: "scale(1 -1)",
    fill: "url(#paint8_diamond_1877_14626)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1229.94,
    height: 846.343,
    transform: "scale(-1 1)",
    fill: "url(#paint8_diamond_1877_14626)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1229.94,
    height: 846.343,
    transform: "scale(-1)",
    fill: "url(#paint8_diamond_1877_14626)",
    opacity: 1,
    shapeRendering: "crispEdges"
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M101 89C101 90.6569 102.343 92 104 92H127.669C129.326 92 130.669 90.6569 130.669 89V76.0118C130.669 74.355 129.326 73.0118 127.669 73.0118H104C102.343 73.0118 101 74.355 101 76.0118V89Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.78823530673980713,\"g\":0.50588238239288330,\"b\":0.99607843160629272,\"a\":1.0},\"position\":0.25999999046325684},{\"color\":{\"r\":0.71319860219955444,\"g\":0.47064134478569031,\"b\":0.98404842615127563,\"a\":1.0},\"position\":0.36000001430511475},{\"color\":{\"r\":0.63169521093368530,\"g\":0.43236324191093445,\"b\":0.97098165750503540,\"a\":1.0},\"position\":0.53500002622604370},{\"color\":{\"r\":0.53117442131042480,\"g\":0.38515356183052063,\"b\":0.95486593246459961,\"a\":1.0},\"position\":0.69499999284744263},{\"color\":{\"r\":0.48043847084045410,\"g\":0.36132541298866272,\"b\":0.94673186540603638,\"a\":1.0},\"position\":0.98366755247116089},{\"color\":{\"r\":0.43960633873939514,\"g\":0.34214857220649719,\"b\":0.9401855468750,\"a\":1.0},\"position\":0.98376756906509399}],\"stopsVar\":[{\"color\":{\"r\":0.78823530673980713,\"g\":0.50588238239288330,\"b\":0.99607843160629272,\"a\":1.0},\"position\":0.25999999046325684},{\"color\":{\"r\":0.71319860219955444,\"g\":0.47064134478569031,\"b\":0.98404842615127563,\"a\":1.0},\"position\":0.36000001430511475},{\"color\":{\"r\":0.63169521093368530,\"g\":0.43236324191093445,\"b\":0.97098165750503540,\"a\":1.0},\"position\":0.53500002622604370},{\"color\":{\"r\":0.53117442131042480,\"g\":0.38515356183052063,\"b\":0.95486593246459961,\"a\":1.0},\"position\":0.69499999284744263},{\"color\":{\"r\":0.48043847084045410,\"g\":0.36132541298866272,\"b\":0.94673186540603638,\"a\":1.0},\"position\":0.98366755247116089},{\"color\":{\"r\":0.43960633873939514,\"g\":0.34214857220649719,\"b\":0.9401855468750,\"a\":1.0},\"position\":0.98376756906509399}],\"transform\":{\"m00\":27.930870056152344,\"m01\":-3.4913651943206787,\"m02\":104.13472747802734,\"m10\":-3.9218077659606934,\"m11\":-31.374460220336914,\"m12\":100.84780883789062},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M113.999 86.6654C112.126 86.6654 111.19 86.6654 110.517 86.216C110.226 86.0214 109.976 85.7714 109.781 85.4802C109.332 84.8076 109.332 83.8713 109.332 81.9987C109.332 80.1261 109.332 79.1898 109.781 78.5172C109.976 78.226 110.226 77.976 110.517 77.7814C111.19 77.332 112.126 77.332 113.999 77.332L117.999 77.332C119.871 77.332 120.808 77.332 121.48 77.7814C121.771 77.976 122.021 78.226 122.216 78.5172C122.665 79.1898 122.665 80.1261 122.665 81.9987C122.665 83.8713 122.665 84.8076 122.216 85.4802C122.021 85.7714 121.771 86.0214 121.48 86.2159C120.808 86.6654 119.871 86.6654 117.999 86.6654H113.999Z",
    stroke: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M114 80C112.895 80 112 80.8954 112 82C112 83.1046 112.895 84 114 84",
    stroke: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M118 80C119.105 80 120 80.8954 120 82C120 83.1046 119.105 84 118 84",
    stroke: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M114 77.332V86.332",
    stroke: "white",
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M118 77.332V86.332",
    stroke: "white",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1877_14626",
    x: 0.825783,
    y: 32.2945,
    width: 146.626,
    height: 146.966,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.55,
    result: "effect1_foregroundBlur_1877_14626"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1877_14626",
    x: 54.307,
    y: 0.330467,
    width: 152.538,
    height: 152.988,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.95,
    result: "effect1_foregroundBlur_1877_14626"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint2_diamond_1877_14626_clip_path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.67301,
    height: 2.6712,
    rx: 0.5,
    transform: "matrix(0.687672 0.726022 -0.712586 0.701585 43.4766 20.4531)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint6_diamond_1877_14626_clip_path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.68148,
    height: 2.67975,
    rx: 0.5,
    transform: "matrix(-0.688002 -0.725708 0.712906 -0.70126 189.203 147.539)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint7_diamond_1877_14626_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.563 94.947C105.1 96.5145 106.804 97.3458 108.37 96.8038L130.737 89.0616C132.303 88.5196 133.137 86.8096 132.6 85.2422L128.009 71.8375C127.472 70.27 125.767 69.4387 124.202 69.9806L101.835 77.7229C100.269 78.2649 99.4348 79.9749 99.9717 81.5423L104.563 94.947Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint8_diamond_1877_14626_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101 89C101 90.6569 102.343 92 104 92H127.669C129.326 92 130.669 90.6569 130.669 89V76.0118C130.669 74.355 129.326 73.0118 127.669 73.0118H104C102.343 73.0118 101 74.355 101 76.0118V89Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1877_14626",
    x1: 43.8086,
    y1: 8.95808,
    x2: 43.8086,
    y2: 69.6753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115124,
    stopColor: "white",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1877_14626",
    x1: 30.2648,
    y1: 21.4258,
    x2: 89.5626,
    y2: 21.4258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "white",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_diamond_1877_14626",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.128086,
    stopColor: "#C981FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786597,
    stopColor: "#7057F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1877_14626",
    x1: 116.663,
    y1: 34.6875,
    x2: 116.663,
    y2: 128.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#735AC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C981FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1877_14626",
    x1: 188.578,
    y1: 159.034,
    x2: 188.578,
    y2: 98.3169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115124,
    stopColor: "white",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1877_14626",
    x1: 202.091,
    y1: 146.539,
    x2: 142.793,
    y2: 146.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "white",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_diamond_1877_14626",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.128086,
    stopColor: "#C981FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786597,
    stopColor: "#7057F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_diamond_1877_14626",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7158F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351278,
    stopColor: "#A28FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D2B98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_diamond_1877_14626",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#C981FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#B678FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#A16EF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#8762F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983668,
    stopColor: "#7B5CF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983768,
    stopColor: "#7057F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpSniperIcon);
export default __webpack_public_path__ + "static/media/LPSniperIcon.e4c6fddcfb9953a269a48c61c80ecb04.svg";
export { ForwardRef as ReactComponent };